import OrderService from "@/services/OrderService";
import moment from "moment";

const state = {
  orderZeitraum: [],
  orderDays: [],
  selectedDay: JSON.parse(localStorage.getItem("selectedOrderDay")) || {
    day: 1,
    date: null
  },
  order: JSON.parse(localStorage.getItem("order")) || {
    customer: {},
    user: {},
    orderDate: null,
    days: [],
    status: "open"
  },
  orders: [],
  ordersearch: "",
  orderFilter: {
    text: "",
    customer: "all",
    startdate: moment().subtract(14, "days"),
    enddate: null,
    status: "all",
    user: "all",
    lieferDatum: true
  }
};

const getters = {
  getOrderSearch(state) {
    return state.ordersearch;
  },
  getOrderFilter(state) {
    return state.orderFilter;
  },
  getOrders() {
    return state.orders;
  },
  getOrderZeitraum(state) {
    return state.orderZeitraum;
  },
  getOrderDays(state) {
    return state.orderDays;
  },
  getOrder(state) {
    return state.order;
  },
  getSelectedDayOrders(state) {
    const dayOrders = state.order.days.filter(
      item => item.day == state.selectedDay.format("DD.MM.YYYY").toString()
    );
    return dayOrders;
  },
  getSelectedDay(state) {
    return state.selectedDay;
  },
  isBestellEnde(state) {
    if (state.order.customer) {
      const current = moment();
      const bestellEndeTag = Number.parseInt(
        state.order.customer.bestellendeTag
      );
      const bestellTimeParts = state.order.customer.bestellendeZeit.split(":");
      const bestellEnde = moment()
        .isoWeekday(bestellEndeTag)
        .hour(bestellTimeParts[0])
        .minute(bestellTimeParts[1])
        .second(0);

      if (
        current.isoWeekday() < bestellEnde.isoWeekday() &&
        current.hour() < bestellEnde.hour() &&
        current.minute() < bestellEnde.minute()
      ) {
        return false;
      }
    }
    return true;
  },
  daySortedOrder(state) {
    const order = state.order.days;
    let days = [];

    for (let index in order) {
      let day = days.find(el => el.day == order[index].day);
      let timeSlotIndex = Number.parseInt(order[index].timeSlot);

      if (!day) {
        day = {
          day: order[index].day,
          meals: []
        };
        days.push(day);
      }

      let mealItem = day.meals.find(
        el => el.meal.gerichtnr == [order[index].meal.gerichtnr]
      );

      if (!mealItem) {
        mealItem = {
          meal: order[index].meal,
          timeSlots: [],
          totalAmount: 0
        };
        day.meals.push(mealItem);
      }

      if (order[index].amount > 0) {
        mealItem.timeSlots[timeSlotIndex] = order[index].amount;
        mealItem.totalAmount += order[index].amount;
      }
    }

    return days;
  }
};

const actions = {
  fetchOrder({ commit }, orderId) {
    return new Promise((resolve, reject) => {
      OrderService.fetch(orderId)
        .then(response => {
          commit("SET_ORDER", response.data.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchOrders({ commit, state }, userId = null) {
    return new Promise((resolve, reject) => {
      OrderService.fetchAll(userId, {
        customer: state.orderFilter.customer._id || null,
        status: state.orderFilter.status,
        startdate: state.orderFilter.startdate,
        enddate: state.orderFilter.enddate,
        lieferDatum: state.orderFilter.lieferDatum,
        user: state.orderFilter.user._id || null
      })
        .then(response => {
          commit("SET_ORDER_LIST", response.data.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  saveOrder({ commit, state }) {
    console.log(state.order);
    return new Promise((resolve, reject) => {
      OrderService.saveOrder(state.order)
        .then(response => {
          console.log(response.data.data);
          commit("SAVE_ORDER", response.data.data);

          resolve(response.data.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  deleteOrder({ commit }, id) {
    return new Promise((resolve, reject) => {
      OrderService.delete(id)
        .then(result => {
          commit("REMOVE_ORDER", id);
          resolve(result);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};

const mutations = {
  INIT_ORDER(state, data) {
    if (localStorage.getItem("selectedOrderDay")) {
      //state.selectedDay = moment(JSON.parse(localStorage.getItem("selectedOrderDay")));
    }

    /* if(localStorage.getItem("order")){
      state.order = JSON.parse(localStorage.getItem("order"));
    } else {*/
    state.selectedDay = data.orderZeitraum[0];
    state.orderZeitraum = data.orderZeitraum;
    state.orderDays = data.orderDays;

    state.order.user = data.user;
    state.order.customer = data.customer;
    state.order.days = [];
    state.order.status = "open";
    // }
  },
  SET_ORDER_SEARCH(state, value) {
    state.ordersearch = value;
  },
  SET_ORDER_FILTER(state, value) {
    state.orderFilter = value;
  },
  SET_ORDER(state, data) {
    state.order = data;
  },
  REMOVE_ORDER(state, id) {
    state.orders = state.orders.filter(item => item._id !== id);
  },
  SET_ORDER_LIST(state, data) {
    state.orders = data;
  },
  SET_SELECTED_DAY(state, day) {
    state.selectedDay = day;
    localStorage.setItem("selectedOrderDay", JSON.stringify(state.selectedDay));
  },
  SAVE_ORDER(state, order) {
    console.log(order);
    state.order = order;
    state.order.status = "saved";
  },

  SET_MEAL_AMOUNT(state, data) {
    let orderItem = state.order.days.find(
      item =>
        item.day == state.selectedDay.format("DD.MM.YYYY") &&
        item.meal._id == data.item._id &&
        item.timeSlot == data.index
    );

    if (orderItem) {
      orderItem.amount = data.amount;
    } else {
      state.order.days.push({
        amount: data.amount,
        meal: data.item,
        timeSlot: data.index,
        day: state.selectedDay.format("DD.MM.YYYY")
      });
    }

    localStorage.setItem("order", JSON.stringify(state.order));
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
